<template>
  <div>
    <el-row>
      <el-col :span="2" :offset="3">
        报表类型
      </el-col>
      <el-col :span="6">
        <cx-select v-model="qc.type" :options="typeList" />
      </el-col>
      <el-col :span="6" :offset="1">
        <el-button type="primary" icon="el-icon-plus"
                 size='mini' @click='add'>生成报表</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qc: {
        type: null
      },
      typeList: [{id: 1, name: '员工花名册'}]
    }
    
  },
  methods: {
    add() {}
  },

  
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/human_affairs/report/list.vue